























































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import httpRequest from '@/services/HttpRequestServiceWithToken'

@Component
export default class StatisticChartGroup extends Vue {

  @Prop()
  private campaignId: string

  private campaignSend: string = ''
  private campaignSendLoading: boolean = false
  private campaignDeliveryRate: string = ''
  private campaignDeliveryRateLoading: boolean = false
  private campaignOpenRate: string = ''
  private campaignOpenRateLoading: boolean = false
  private campaignClickRate: string = ''
  private campaignClickRateLoading: boolean = false

  @Watch('campaignId')
  private async getUCampaignSend() {
    this.campaignSendLoading = true
    const url = process.env.VUE_APP_BASEURL + '/v2/report/' + this.campaignId + '/detail/sent'
    await httpRequest.get(url, {}, (response: any) => {
      this.campaignSend = response
    }).catch(
      (e) => console.log(e),
    ).finally(() => {
      this.campaignSendLoading = false
    })
  }

  @Watch('campaignId')
  private async getUCampaignDeliveryRate() {
    this.campaignDeliveryRateLoading = true
    const url = process.env.VUE_APP_BASEURL + '/v2/report/' + this.campaignId + '/detail/delivered'
    await httpRequest.get(url, {}, (response: any) => {
      this.campaignDeliveryRate = response
    }).catch(
      (e) => console.log(e),
    ).finally(() => {
      this.campaignDeliveryRateLoading = false
    })
  }

  @Watch('campaignId')
  private async getUCampaignOpenRate() {
    this.campaignOpenRateLoading = true
    const url = process.env.VUE_APP_BASEURL + '/v2/report/' + this.campaignId + '/detail/open'
    await httpRequest.get(url, {}, (response: any) => {
      this.campaignOpenRate = response
    }).catch(
      (e) => console.log(e),
    ).finally(() => {
      this.campaignOpenRateLoading = false
    })
  }

  @Watch('campaignId')
  private async getUCampaignClickRate() {
    this.campaignClickRateLoading = true
    const url = process.env.VUE_APP_BASEURL + '/v2/report/' + this.campaignId + '/detail/click'
    await httpRequest.get(url, {}, (response: any) => {
      this.campaignClickRate = response
    }).catch(
      (e) => console.log(e),
    ).finally(() => {
      this.campaignClickRateLoading = false
    })
  }

  private getCurrentBreakpoint() {
    if (this.$vuetify.breakpoint.xsOnly) {
      return 'xs'
    } else if (this.$vuetify.breakpoint.smOnly) {
      return 'sm'
    } else {
      return 'md'
    }
  }
  private created() {
    console.log(this.campaignId)
  }
}
